<template>
  <div class="dashboard-log-setting-tree">
    <el-tree
      class="tree-checkbox"
      ref="logTypeTree"
      :data="treeData"
      :props="defaultProps"
      :node-key="defaultProps.treeKey"
      :show-checkbox="(treeType === TREE_CONST.TYPE.CHECK) ? true : false"
      :default-expand-all="true"
      :expand-on-click-node="false"
      :highlight-current="(treeType === TREE_CONST.TYPE.CHECK) ? false : true"
      @node-click="selectTreeNode"
      v-on="(treeType === TREE_CONST.TYPE.CHECK) ? {'check-change': onCheckChange} : {'node-click': onNodeClick }"
    >
    </el-tree>
  </div>
</template>

<script>
import { defaultProps } from '@/constants/tree';
import DashboardConst from '@/constants/dashboard';
import isNil from 'lodash/isNil';
import { isEmpty } from '@/utils/basic';
import { getPathNodes } from '@/utils/tree';


const TREE_CONST = DashboardConst.TREE_CONST;

export default {
  name: 'WLogTypeTree',
  // mixins: [RouterTree],
  props: {
    /**
     * [트리 타입 : check인지 single인지 ]
     * @type {String}
     */
    treeType: {
      type: String,
      default: TREE_CONST.TYPE.DEFAULT,
    },
    /**
     * [트리 기존 설정 노드]
     * @type {Object}
     */
    selecetedNode: {
      type: [Object, Array],
      default: () => {},
    },
  },
  data() {
    return {
      defaultProps,
      treeData: [],
      isNil,
      TREE_CONST,
    };
  },
  mounted() {
  },
  methods: {
    selectTreeNode(value) {
      this.$emit('selectTreeNode', value);
    },
    setData(data) {
      this.treeData = data;
    },
    initTreeData() {
      this.treeData = [];
      this.initSelectionOrCheck();
    },
    initSelectionOrCheck() {
      if (this.treeType === TREE_CONST.TYPE.CHECK) {
        this.$refs.logTypeTree.setCheckedKeys([]);
      } else if (this.treeType === TREE_CONST.TYPE.UNCHECK) {
        this.$refs.logTypeTree.setCurrentNode([]);
      }
    },
    getCurrentNode() {
      if (this.treeType === TREE_CONST.TYPE.CHECK) {
        const currentCheckdNode = this.$refs.logTypeTree.getCheckedNodes();
        return currentCheckdNode.reduce((accumulator, value) => {
          accumulator.nodes.push(value);
          accumulator.treeKeys.push(value.treeKey);
          return accumulator;
        }, { nodes: [], treeKeys: [] });
      } else if (this.treeType === TREE_CONST.TYPE.UNCHECK) {
        const currentNode = this.$refs.logTypeTree.getCurrentNode();
        if (!isEmpty(currentNode) && currentNode.type !== 'root' && currentNode.type !== 'group') {
          return {
            nodes: [this.$refs.logTypeTree.getCurrentNode()],
            treeKeys: [this.$refs.logTypeTree.getCurrentNode().treeKey],
          };
        }
      }
      return {
        nodes: [],
        treeKeys: [],
      };
    },
    setDefaultNodeByTreeKey(newNodeTreeKeyList) {
      this.expandNodeByTreeKey(newNodeTreeKeyList);
      if (this.treeType === TREE_CONST.TYPE.CHECK) {
        this.$refs.logTypeTree.setCheckedKeys(newNodeTreeKeyList);
      } else if (this.treeType === TREE_CONST.TYPE.UNCHECK) {
        this.$refs.logTypeTree.setCurrentKey(newNodeTreeKeyList[0]);
      }
    },
    onCheckChange() {
      this.$emit('update:selectedNode', this.getCurrentNode().treeKeys);
    },
    onNodeClick(clickedNode) {
      const resultNode = clickedNode.children ? [] : [clickedNode.treeKey];
      this.$emit('update:selectedNode', resultNode);
    },
    expandNodeByTreeKey(treeKeys) {
      if (isEmpty(treeKeys)) {
        return;
      }
      treeKeys.forEach((treeKey) => {
        const node = this.$refs.logTypeTree.getNode(treeKey);
        const path = getPathNodes(node);
        path.forEach((item) => {
          if (!item.isLeaf) item.expanded = true;
        });
      });
    },
  },
};
</script>
<style lang="scss">
.dashboard-log-setting-tree {
  .tree-checkbox {
    .el-tree-node__expand-icon {
      margin-right: 0px;
    }

    .el-tree-node__label {
      white-space: nowrap;
      overflow-x: hidden;
      text-overflow: ellipsis;
      line-height: 2 !important;
    }
  }
}
</style>
<style module>
.tree {
  height: calc(100% - 55px) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/grid/setting/components/LogTypeTree.vue